import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

export default function useResponsive(delay = 100) {
  // Can implement width, height, tablet, and desktop if needed
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const tabletBreakpoint = 1023; // 1023px includes iPad Pro 12.9

  const checkForMobile = () => {
    // 480px includes Galaxy Note 5 & iPhone 14 Pro Max
    setIsMobile(window.innerWidth <= 480);
  };

  const checkForTablet = () => {
    setIsTablet(window.innerWidth <= tabletBreakpoint);
  };

  useEffect(() => {
    // checking if mobile on load/refresh
    checkForMobile();
    checkForTablet();

    const debouncedHandleResize = debounce(checkForMobile, delay);
    const debouncedHandleTablet = debounce(checkForTablet, delay);

    window.addEventListener('resize', debouncedHandleResize);
    window.addEventListener('resize', debouncedHandleTablet);
    return () => {
      window.removeEventListener('resize', debouncedHandleResize);
      window.removeEventListener('resize', debouncedHandleTablet);
    };
  }, [delay]);

  return { isMobile, isTablet };
}
